<template>
  <div class="project-rep-remarks">
    <label>{{ $t('comments') }}</label>
    <HKLInput v-model="remarksContent" />
    <HKLButton
      color="orange"
      action="review"
      @click="() => remarkReview()"
    />
  </div>
</template>
<script>
import { ref, unref } from 'vue-demi'
import HKLInput from '@/controls/Input/HKLInput.vue'
import HKLButton from '@/controls/Button/HKLButton.vue'

const EVENT = 'review'

export default {
  components: {
    HKLInput,
    HKLButton,
  },
  setup (_, { emit }) {
    let returnData = {}
    // #region Remarks
    const remarksContent = ref('')
    const remarkReview = () => {
      emit(EVENT, unref(remarksContent), { remarks: remarksContent })
    }
    returnData = {
      ...returnData,
      remarksContent,
      remarkReview,
    }
    // #endregion Remarks
    return returnData
  },
}
</script>
<style scoped lang="scss">
.project-rep-remarks {
  padding-bottom: 10px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  label {
    flex-basis: 100%;
  }
  .hkl-input-box {
    flex-basis: 50%;
  }
  .hkl-button {
    margin-right: 8px;
  }
}
</style>
